module.exports = __webpack_public_path__ + "static/media/Logistics_Vector.29e852ab.svg";